<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field placeholder="Số điện thoại" v-model="phone" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field placeholder="Họ tên PHHS" v-model="buyerName" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field placeholder="Email" v-model="email" clearable flat outlined dense hide-details />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="primary" height="40px" width="100%" outlined @click="onFilterChanged"> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Hình thức học"
              :items="studentLearningMethodOptions"
              item-text="value"
              item-value="key"
              v-model="studentLearningMethods"
            />
          </v-col>
          <v-col class="pb-0" cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Khoá học muốn tham gia"
              :items="studentProductOptions"
              item-text="value"
              item-value="key"
              v-model="studentProducts"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Cơ sở đăng ký"
              :items="studentDepartmentOptions"
              item-text="value"
              item-value="key"
              v-model="studentDepartments"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" md="4">
            <v-text-field
              v-model="studentNameSearchField"
              placeholder="Tên học sinh"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Nguồn marketing"
              :items="LEAD_IMPORT_ORIGIN_OPTIONS"
              v-model="importOrigin"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              placeholder="Người chịu trách nhiệm"
              v-model="inCharge"
              :items="formattedUsers"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-show="advancedFilter"
              item-text="title"
              item-value="value"
              placeholder="Phân khúc"
              v-model="segment"
              :items="segmentOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-show="advancedFilter"
              item-text="title"
              item-value="value"
              placeholder="Sản phẩm quan tâm"
              v-model="product"
              :items="formattedProducts"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-show="advancedFilter"
              item-text="title"
              item-value="value"
              v-model="interest"
              placeholder="Mức độ quan tâm"
              :items="interestOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="primary" height="40px" width="100%" @click="advancedFilter = !advancedFilter" text>
          Nâng cao <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon
          ><v-icon v-if="advancedFilter">mdi-chevron-up</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-show="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="studentSchoolSearchField"
              placeholder="Trường đang học"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="expectSchoolSearchField"
              clearable
              flat
              outlined
              dense
              hide-details
              placeholder="Trường dự định thi vào"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-show="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Năm học"
              :items="schoolYears"
              v-model="selectedSchoolYear"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-show="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-body-2 mb-2 black--text font-weight-medium">Ngày, giờ lịch hẹn</div>
          </v-col>
          <v-col cols="12" md="4">
            <DatePicker v-model="appointmentDateFrom" label="Từ ngày (DD/MM/YYYY)" style="width: 100%" clearable />
          </v-col>
          <v-col cols="12" md="4">
            <TimeInput
              v-model="appointmentDateFromTime"
              :selectedDate="appointmentDateFromSelectedDate"
              label="Từ giờ (HH:mm)"
              style="width: 100%"
              clearable
              return-time
            />
          </v-col>
          <v-col class="d-none d-md-block" md="4" />
          <v-col cols="12" md="4">
            <DatePicker v-model="appointmentDateTo" label="Đến ngày (DD/MM/YYYY)" style="width: 100%" clearable />
          </v-col>
          <v-col cols="12" md="4">
            <TimeInput
              v-model="appointmentDateToTime"
              :selectedDate="appointmentDateToSelectedDate"
              label="Đến giờ (HH:mm)"
              style="width: 100%"
              clearable
              return-time
            />
          </v-col>
          <v-col class="d-none d-md-block" md="4" />
        </v-row>
      </v-col>
    </v-row>
    <v-row v-show="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" md="10">
        <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-body-2 mb-2 black--text font-weight-medium">Ngày, giờ làm test</div>
          </v-col>
          <v-col cols="12" md="4">
            <DatePicker v-model="testDateFrom" label="Từ ngày (DD/MM/YYYY)" style="width: 100%" clearable />
          </v-col>
          <v-col cols="12" md="4">
            <TimeInput
              v-model="testDateFromTime"
              :selectedDate="testDateFromSelectedDate"
              label="Từ giờ (HH:mm)"
              style="width: 100%"
              clearable
              return-time
            />
          </v-col>
          <v-col class="d-none d-md-block" md="4" />
          <v-col cols="12" md="4">
            <DatePicker v-model="testDateTo" label="Đến ngày (DD/MM/YYYY)" style="width: 100%" clearable />
          </v-col>
          <v-col cols="12" md="4">
            <TimeInput
              v-model="testDateToTime"
              :selectedDate="testDateToSelectedDate"
              label="Đến giờ (HH:mm)"
              style="width: 100%"
              clearable
              return-time
            />
          </v-col>
          <v-col class="d-none d-md-block" md="4" />
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import eleSchool from '@/assets/ele_school.json'
import secondarySchool from '@/assets/secondary_school.json'
import highSchool from '@/assets/high_school.json'
import utils from '@/plugins/utils'
import { mapGetters } from 'vuex'
import { CONFIG_KEYS, LEAD_IMPORT_ORIGIN_OPTIONS } from './helpers'
import get from 'lodash-es/get'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import TimeInput from '@/components/basic/TimeInput.vue'
import {
  buildHoChiMinhDateBoundaryISOString,
  buildHoChiMinhDateTimeISOString,
  formatHoChiMinhDate,
  formatHoChiMinhTime,
} from '@/helpers/dateTime'

const TIME_FORMAT = /^\d{2}:\d{2}$/

export default {
  components: { DatePicker, TimeInput },
  computed: {
    ...mapGetters({ products: 'product/products', configs: 'leadConfig/configs' }),
    formattedProducts() {
      return this.products.map(p => ({ title: p.title, value: p.id }))
    },
    formattedUsers() {
      return this.users.map(u => ({ text: u.name ? u.name : u.username, value: u.id }))
    },
    studentLearningMethodOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_LEARNING_METHOD)
      return get(config, 'value', [])
    },
    studentProductOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_PRODUCT)
      return get(config, 'value', [])
    },
    studentDepartmentOptions() {
      const config = this.configs.find(c => c.key === CONFIG_KEYS.STUDENT_DEPARTMENT)
      return get(config, 'value', [])
    },
    appointmentDateFromSelectedDate() {
      return this.formatDateInput(this.appointmentDateFrom)
    },
    appointmentDateToSelectedDate() {
      return this.formatDateInput(this.appointmentDateTo)
    },
    testDateFromSelectedDate() {
      return this.formatDateInput(this.testDateFrom)
    },
    testDateToSelectedDate() {
      return this.formatDateInput(this.testDateTo)
    },
  },
  props: {
    users: Array,
  },
  data() {
    return {
      LEAD_IMPORT_ORIGIN_OPTIONS,
      //
      advancedFilter: false,
      show: false,
      phone: '',
      buyerName: '',
      email: '',
      studentNameSearchField: '',
      studentClassSearchField: '',
      studentSchoolSearchField: '',
      expectSchoolSearchField: '',
      type: '',
      product: [],
      inCharge: [],
      importOrigin: '',
      studentExpectation: '',
      selectedSchoolYear: '2023-2024',
      segment: {},
      interest: {},
      segmentOptions: [
        { title: 'Phổ thông', value: 'intermediate' },
        { title: 'Cao cấp', value: 'advance' },
      ],
      interestOptions: [
        { title: 'Thấp', value: 'cold' },
        { title: 'Vừa', value: 'warm' },
        { title: 'Cao', value: 'hot' },
      ],
      schoolOptions: [...eleSchool, ...secondarySchool, ...highSchool],
      // TODO: get school-year from server instead
      schoolYears: [{ title: 'Năm học 2023-2024', value: '2023-2024' }],
      studentLearningMethods: '',
      studentProducts: '',
      studentDepartments: '',
      appointmentDateFrom: '',
      appointmentDateTo: '',
      appointmentDateFromTime: '',
      appointmentDateToTime: '',
      testDateFrom: '',
      testDateTo: '',
      testDateFromTime: '',
      testDateToTime: '',
    }
  },
  methods: {
    formatDateInput(date) {
      return formatHoChiMinhDate(date, true)
    },
    formatTimeInput(time) {
      if (!time) return ''
      if (TIME_FORMAT.test(time)) return time
      return formatHoChiMinhTime(time)
    },
    buildDateTime(date, time, defaultBoundary) {
      if (!date) return ''

      const dateText = this.formatDateInput(date)
      if (time) {
        return buildHoChiMinhDateTimeISOString(dateText, this.formatTimeInput(time))
      }

      return buildHoChiMinhDateBoundaryISOString(dateText, defaultBoundary)
    },
    getDateBounds(fromDate, fromTime, toDate, toTime) {
      let from = this.buildDateTime(fromDate, fromTime, 'start')
      let to = this.buildDateTime(toDate, toTime, 'end')

      if (from && to && new Date(from).getTime() > new Date(to).getTime()) {
        const temp = from
        from = to
        to = temp
      }

      return { from, to }
    },
    getDateRangeQuery(field, fromDate, fromTime, toDate, toTime) {
      const { from, to } = this.getDateBounds(fromDate, fromTime, toDate, toTime)
      const query = {}

      if (from) query[`${field}_gte`] = from
      if (to) query[`${field}_lte`] = to

      return query
    },
    getTestDateQuery() {
      return this.getDateRangeQuery(
        'testDate',
        this.testDateFrom,
        this.testDateFromTime,
        this.testDateTo,
        this.testDateToTime
      )
    },
    getAppointmentDateQuery() {
      return this.getDateRangeQuery(
        'appointmentDate',
        this.appointmentDateFrom,
        this.appointmentDateFromTime,
        this.appointmentDateTo,
        this.appointmentDateToTime
      )
    },
    onFilterChanged() {
      let query = {
        phone_contains: this.phone,
        buyerName_contains: this.buyerName,
        email_contains: this.email,
        products: this.product,
        inCharge: this.inCharge,
        studentNameSearchField_contains: this.studentNameSearchField
          ? utils.removeUnicode(this.studentNameSearchField)
          : '',
        studentSchoolSearchField_contains: this.studentSchoolSearchField
          ? utils.removeUnicode(this.studentSchoolSearchField)
          : '',
        studentClassSearchField_contains: this.studentClassSearchField
          ? utils.removeUnicode(this.studentClassSearchField)
          : '',
        studentExpectSchoolSearchField_contains: this.expectSchoolSearchField
          ? utils.removeUnicode(this.expectSchoolSearchField)
          : '',
        importOrigin_contains: this.importOrigin,
        interest: this.interest,
        segment: this.segment,
        studentLearningMethods: this.studentLearningMethods,
        studentProducts: this.studentProducts,
        studentDepartments: this.studentDepartments,
        ...this.getTestDateQuery(),
        ...this.getAppointmentDateQuery(),
      }

      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
